const File = {

    "premise": "Premise",
    "folder": "Folder",
    "file_name": "File Name",
    "description": "Description",
    "document_upload": "Document Upload",
    "search": "Search",

    "file": "File",
    "files": "Files",

    "error_premise": "Select Premise",
    "error_folder": "Select Folder",
    "error_file_name": "Enter File Name",
    "error_document": "Upload Document",

    "table_folder": "FOLDER",
    "table_name": "FILE NAME",
    "table_description": "DESCRIPTION",
    "table_premise": "PREMISE",
}

export default File;